var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#217346;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Excel_48x1_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_48",
    "data-name": 48
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38,
    y: 13,
    width: 28,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,13V59H38V13H66m0-2H38a2,2,0,0,0-2,2V59a2,2,0,0,0,2,2H66a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,17H61v5H51Zm0,13H61V25H51Zm0,24H61V49H51Zm0-16H61V33H51Zm0,8H61V41H51ZM38,22H48V17H38Zm0,8H48V25H38Zm0,24H48V49H38Zm0-16H48V33H38Zm0,8H48V41H38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,4,4,11V61l38,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.23,24l-5.14.31L22,31.63l-.2.66-.17.57-.13.48-.1.39H21.3q-.06-.29-.13-.56T21,32.66q-.07-.25-.15-.48t-.16-.45l-2.69-7-5,.3L18.36,36.5,12.6,47.92l4.83.29,3.25-7.49.15-.52.12-.45.1-.38q0-.17.07-.31h.05q.05.3.1.55t.1.45q0,.2.09.35a2.49,2.49,0,0,0,.09.25l3.38,8L30.4,49,24.12,36.39,30.23,24"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.e75fbb1ad9e692c2c40d2e205b309053.svg";
export { ForwardRef as ReactComponent };